import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { CopticPeoplePage } from './pages/CopticPeoplePage';
import { BlogPage } from './pages/BlogPage';
import { ContactPage } from './pages/ContactPage';
import { DonatePage } from './pages/DonatePage';
import { Layout } from './components/layout/Layout';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Layout data-id="element-4">
              <HomePage data-id="element-5" />
            </Layout>} data-id="element-3" />
        <Route path="/about" element={<Layout data-id="element-7">
              <AboutPage data-id="element-8" />
            </Layout>} data-id="element-6" />
        <Route path="/coptic-people" element={<Layout data-id="element-10">
              <CopticPeoplePage data-id="element-11" />
            </Layout>} data-id="element-9" />
        <Route path="/blog" element={<Layout data-id="element-13">
              <BlogPage data-id="element-14" />
            </Layout>} data-id="element-12" />
        <Route path="/contact" element={<Layout data-id="element-16">
              <ContactPage data-id="element-17" />
            </Layout>} data-id="element-15" />
        <Route path="/donate" element={<Layout data-id="element-19">
              <DonatePage data-id="element-20" />
            </Layout>} data-id="element-18" />
      </Routes>
    </BrowserRouter>;
}